var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h4",
              { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
              [_vm._v(_vm._s(_vm.$t("txtLogPrint")))]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.reportType,
                    expression: "reportType"
                  }
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  id: "printDetail",
                  name: "printRadio",
                  value: "detail"
                },
                domProps: { checked: _vm._q(_vm.reportType, "detail") },
                on: {
                  change: function($event) {
                    _vm.reportType = "detail"
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "printDetail" }
                },
                [_vm._v("Detail Report (Selection)")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "custom-control custom-radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.reportType,
                    expression: "reportType"
                  }
                ],
                staticClass: "custom-control-input",
                attrs: {
                  type: "radio",
                  id: "printOverview",
                  name: "printRadio",
                  value: "overview"
                },
                domProps: { checked: _vm._q(_vm.reportType, "overview") },
                on: {
                  change: function($event) {
                    _vm.reportType = "overview"
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "printOverview" }
                },
                [_vm._v("Overview Report (From-To)")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_vm._v(_vm._s(_vm.$t("btnClose")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.printReport()
                  }
                }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("txtLogPrint")) + "\n        "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }